var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.topType === "black" ? "top-header-black" : "top-header" },
    [
      _c("a", {
        staticClass: "back",
        attrs: { uigs: "head_back", href: "javascript:history.go(-1)" },
      }),
      _vm._v(" "),
      _c("h1", [_vm._v(_vm._s(_vm.title))]),
      _vm._v(" "),
      _c("a", {
        staticClass: "home",
        attrs: { href: "/?source=node&spver=" + _vm.spver, uigs: "head_home" },
      }),
      _vm._v(" "),
      _c("a", {
        staticClass: "search",
        attrs: { href: "/hotsugg?spver=" + _vm.spver, uigs: "head_search" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }